module.exports = __webpack_public_path__ + "static/experience-b6c377980e0de8ada7a151de983ee0f0.jpg";